export const STEPS_SET_STEP = 'STEPS_SET_STEP';
export const STEPS_BACK_STEP = 'STEPS_BACK_STEP';
export const STEPS_FOWARD_STEP = 'STEPS_FOWARD_STEP';
export const STEPS_RESET = 'STEPS_RESET';
